app = angular.module( 'workflow.app' )

app.controller( 'WorkerController', require( './WorkerController' ))
